import Vuex from "vuex";
import Vue from "vue";
import VueResource from "vue-resource";
import ProductFinder from '@productfinder/app/product-finder.vue';
import { productFinderStore } from "@productfinder/store/productFinderStore";

export const productFinder = {
    init: () => {
        if (document.getElementById('product-finder') !== null) {
            Vue.use(VueResource);
            Vue.use(Vuex);

            new Vue({
                store: productFinderStore,
                render: h => h(ProductFinder, {
                    props: {}
                })
            }).$mount('#product-finder');
        }
    }
};
